import { render, staticRenderFns } from "./3_InterdictionAccueil.vue?vue&type=template&id=4fd64e5a&scoped=true&"
import script from "./3_InterdictionAccueil.vue?vue&type=script&lang=js&"
export * from "./3_InterdictionAccueil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd64e5a",
  null
  
)

export default component.exports